(function(){
  /* Scope check — bail out if the widget isn't on this page. */
  var root = document.querySelector('.cg-cs-root');
  if (!root) return;

  /* Re-query inside root so multiple instances on a page would be possible
     down the line. For now, single-instance per page is the supported case. */
  var ids = ['paperQty','tissueQty','soapQty','linerQty','paperPrice','tissuePrice','soapPrice','linerPrice','other','cushion'];
  var els = {};
  ids.forEach(function(id){ els[id] = root.querySelector('#cg-cs-' + id); });

  /* If any control is missing, the markup is broken — abort silently. */
  for (var i = 0; i < ids.length; i++){ if (!els[ids[i]]) return; }

  var displays = {
    paperQty:    root.querySelector('#cg-cs-paperQtyVal'),
    tissueQty:   root.querySelector('#cg-cs-tissueQtyVal'),
    soapQty:     root.querySelector('#cg-cs-soapQtyVal'),
    linerQty:    root.querySelector('#cg-cs-linerQtyVal'),
    paperPrice:  root.querySelector('#cg-cs-paperPriceVal'),
    tissuePrice: root.querySelector('#cg-cs-tissuePriceVal'),
    soapPrice:   root.querySelector('#cg-cs-soapPriceVal'),
    linerPrice:  root.querySelector('#cg-cs-linerPriceVal'),
    other:       root.querySelector('#cg-cs-otherVal'),
    cushion:     root.querySelector('#cg-cs-cushionVal')
  };

  var outputs = {
    paper:        root.querySelector('#cg-cs-outPaper'),
    tissue:       root.querySelector('#cg-cs-outTissue'),
    soap:         root.querySelector('#cg-cs-outSoap'),
    liners:       root.querySelector('#cg-cs-outLiners'),
    other:        root.querySelector('#cg-cs-outOther'),
    otherRow:     root.querySelector('#cg-cs-outOtherRow'),
    cushion:      root.querySelector('#cg-cs-outCushion'),
    cushionRow:   root.querySelector('#cg-cs-outCushionRow'),
    total:        root.querySelector('#cg-cs-outTotal'),
    barPaper:     root.querySelector('#cg-cs-barPaper'),
    barTissue:    root.querySelector('#cg-cs-barTissue'),
    barSoap:      root.querySelector('#cg-cs-barSoap'),
    barLiners:    root.querySelector('#cg-cs-barLiners'),
    barOther:     root.querySelector('#cg-cs-barOther'),
    barCushion:   root.querySelector('#cg-cs-barCushion'),
    legendOther:  root.querySelector('#cg-cs-legendOther'),
    legendCushion:root.querySelector('#cg-cs-legendCushion')
  };

  function num(id){
    var el = els[id];
    if (!el) return 0;
    var v = parseFloat(el.value);
    return isNaN(v) ? 0 : v;
  }
  function money(v){
    if (!isFinite(v) || v < 0) v = 0;
    return '$' + Math.round(v).toLocaleString('en-US');
  }
  function qtyText(v){
    return (v % 1 === 0) ? v.toFixed(0) : v.toFixed(1);
  }

  function updateDisplays(){
    displays.paperQty.textContent    = qtyText(num('paperQty'));
    displays.tissueQty.textContent   = qtyText(num('tissueQty'));
    displays.soapQty.textContent     = qtyText(num('soapQty'));
    displays.linerQty.textContent    = qtyText(num('linerQty'));
    displays.paperPrice.textContent  = Math.round(num('paperPrice')).toString();
    displays.tissuePrice.textContent = Math.round(num('tissuePrice')).toString();
    displays.soapPrice.textContent   = Math.round(num('soapPrice')).toString();
    displays.linerPrice.textContent  = Math.round(num('linerPrice')).toString();
    displays.other.textContent       = Math.round(num('other')).toString();
    displays.cushion.textContent     = num('cushion').toString();
  }

  function recalc(){
    updateDisplays();

    var paperCost  = num('paperQty')  * num('paperPrice');
    var tissueCost = num('tissueQty') * num('tissuePrice');
    var soapCost   = num('soapQty')   * num('soapPrice');
    var linerCost  = num('linerQty')  * num('linerPrice');
    var other      = num('other');
    var cushPct    = num('cushion') / 100;

    var supplySubtotal = paperCost + tissueCost + soapCost + linerCost + other;
    var cushionCost = supplySubtotal * cushPct;
    var total = supplySubtotal + cushionCost;

    outputs.paper.textContent   = money(paperCost);
    outputs.tissue.textContent  = money(tissueCost);
    outputs.soap.textContent    = money(soapCost);
    outputs.liners.textContent  = money(linerCost);
    outputs.other.textContent   = money(other);
    outputs.cushion.textContent = money(cushionCost);
    outputs.total.textContent   = money(total);

    /* Show/hide optional rows and legend dots */
    outputs.otherRow.style.display = other > 0 ? '' : 'none';
    if (outputs.legendOther) outputs.legendOther.style.display = other > 0 ? '' : 'none';

    outputs.cushionRow.style.display = cushionCost > 0 ? '' : 'none';
    if (outputs.legendCushion) outputs.legendCushion.style.display = cushionCost > 0 ? '' : 'none';

    /* Stacked bar percentages */
    var coreTotal = paperCost + tissueCost + soapCost + linerCost + other + cushionCost;
    function pct(v){
      if (coreTotal <= 0) return 0;
      return (v / coreTotal) * 100;
    }
    outputs.barPaper.style.width   = pct(paperCost) + '%';
    outputs.barTissue.style.width  = pct(tissueCost) + '%';
    outputs.barSoap.style.width    = pct(soapCost) + '%';
    outputs.barLiners.style.width  = pct(linerCost) + '%';
    outputs.barOther.style.width   = pct(other) + '%';
    outputs.barCushion.style.width = pct(cushionCost) + '%';
  }

  /* Wire input events via addEventListener (no inline handlers) */
  ids.forEach(function(id){
    if (els[id]) els[id].addEventListener('input', recalc);
  });

  recalc();
})();
